import { routing } from "../../routing.js";
export function createClient(api) {
  async function get(id) {
    const {
      job
    } = await api.get(`${routing.jobsUrl}/${id}`);
    return job.state;
  }
  return {
    get
  };
}